export default __webpack_public_path__ + "static/logos-sig-con-786a1cffadc391332b2dd4f14bccb9fe.jpg";